/**
 * Canonieke site-URL voor meta tags (canonical, og:url).
 * Overschrijf in .env: VITE_SITE_URL=https://www.jouwdomein.nl
 */
const raw = (import.meta.env.VITE_SITE_URL ?? 'https://www.calqtool.com').trim();

export const SITE_ORIGIN = raw.replace(/\/$/, '');

export function canonicalUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${p === '/' ? '' : p}`;
}

/** Standaard OG-afbeelding (PNG werkt beter dan SVG voor social previews). */
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/assets/Favicon.png`;

/** Standaard beschrijving van de OG-afbeelding (toegankelijkheid social previews). */
export const DEFAULT_OG_IMAGE_ALT = 'CalqTool™ — logo en merk voor bouwcalculaties';
